/* eslint-disable react-refresh/only-export-components */
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { CreateSalesOrderPage } from '@/app/(client)/orders/-components/CreateSalesOrderPage';
import { useCreateSalesOrderPage } from '@/app/(client)/orders/-hooks/useCreateSalesOrderPage';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(create)/sales-orders/create/',
)({
  validateSearch: (search: Record<string, unknown>) => ({
    step:
      typeof search.step === 'number' && search.step >= 1 && search.step <= 3
        ? (search.step as 1 | 2 | 3)
        : 1,
  }),
  component: CreateSalesOrderCreatePage,
});

function CreateSalesOrderCreatePage() {
  const navigate = useNavigate({ from: Route.fullPath });
  const { step } = Route.useSearch();
  const currentStep = step ?? 1;

  function setStep(s: number) {
    void navigate({ search: { step: s as 1 | 2 | 3 }, replace: false });
  }

  const pageProps = useCreateSalesOrderPage(currentStep, undefined, setStep);
  const { form } = pageProps;

  useEffect(() => {
    if (currentStep > 1 && !form.getValues('buyerId')) {
      void navigate({ search: { step: 1 }, replace: true });
    }
  }, [currentStep, form, navigate]);

  return <CreateSalesOrderPage {...pageProps} currentStep={currentStep} />;
}
